import { render, staticRenderFns } from "./VuesticChat.vue?vue&type=template&id=590d1360&scoped=true"
import script from "./VuesticChat.vue?vue&type=script&lang=js"
export * from "./VuesticChat.vue?vue&type=script&lang=js"
import style0 from "./VuesticChat.vue?vue&type=style&index=0&id=590d1360&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590d1360",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('590d1360')) {
      api.createRecord('590d1360', component.options)
    } else {
      api.reload('590d1360', component.options)
    }
    module.hot.accept("./VuesticChat.vue?vue&type=template&id=590d1360&scoped=true", function () {
      api.rerender('590d1360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-chat/VuesticChat.vue"
export default component.exports